import { CommonModule } from '@angular/common';
import { Component, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserService } from '../user.service';
import { TenantView } from '../models';
import { Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-info',
  imports: [FormsModule, CommonModule, RouterModule, RouterLink, RouterLinkActive],
  templateUrl: './user-info.html',
  styleUrl: './user-info.scss',

})
export class UserInfo {

	protected tenant : TenantView | null = null;
	protected year = new Date().getFullYear();
	protected language : number  = 1; //default to English
	constructor( protected _userService: UserService, public router: Router, ) {
		effect(() => {
			this.tenant = this._userService.currentTennant();
			this.language = this.tenant ? this.tenant.Language : 1;
		});
	}

	async setLanguage(lang: number) {
		let resp = await this._userService.setLanguage(lang);
		console.log('Set language response:', resp);
		if( resp.success ) {
			//language updated
			this.language = lang;
			//reload the page to reflect language change
			location.reload();
		}
	}

	contentStrings : Record<string, Record<number, string>> = {
		LoggedInAs: { 1: "Logged in as", 2: "ログインユーザー" },
		MyWorkOrders: { 1: "My Work Orders", 2: "マイ作業指示" },
		RequestWork: { 1: "Request Work", 2: "作業指示を依頼する" },
		Logout: { 1: "Logout", 2: "ログアウト" },
		LanguageJapanese: { 1: "Language: Japanese", 2: "言語：日本語" },
		LanguageEnglish: { 1: "Language: English", 2: "言語：英語" },
		LastLogin: { 1: "Last Login", 2: "最終ログイン" },
		Home: { 1: "Home", 2: "ホーム" },
		EventCalendar: { 1: "Event Calendar", 2: "イベントカレンダー" },
		PayMyRent: { 1: "Pay My Rent", 2: "家賃を支払う" },
		SharedDocuments: { 1: "Shared Documents", 2: "共有ドキュメント" },
		Insurance: { 1: "Insurance", 2: "保険" },
		PropertyDetails: { 1: "Property Details", 2: "物件詳細" },
		AccountProfile: { 1: "Account Profile", 2: "アカウントプロフィール" },
		HelpDesk: { 1: "Help Desk", 2: "ヘルプデスク" },
		ContactUs: { 1: "Contact Us", 2: "お問い合わせ" },
	}

	async logout() {
		console.log('Logging out user');
		let response = await this._userService.logoutFromServer();
		if (response.success) {
			// Optionally, redirect the user or show a message
			let alertmsg = 'You have been logged out';
			if ( this.tenant && this.tenant.Language == 2 ) {
				//japanese
				alertmsg = 'ログアウトしました';
			}
			this.tenant = null;
			alert(alertmsg);
			location.reload();
		}
	}
}	
